import "../../pages/payment/index.css";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect } from "react";
import moment from "moment";
import templeJson from "../../config/temple.json";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
  Container,
  Grid,
  Card,
  CardContent,
  Box,
  CardHeader,
  Button,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";

import { useDispatch } from "react-redux";
import { updateCart } from "../../actions";
import { yupResolver } from "@hookform/resolvers/yup";
import { MuiTelInput } from "mui-tel-input";
import { Add, Remove } from "@mui/icons-material";
import ConsentDialog from "../../components/common/ConsentDialog";
import toast from "react-hot-toast";
// Define yup schema for form validation

export default function Checkout(props) {
  const location = useLocation();
  const currentUrlPath = location.pathname;
  const dispatch = useDispatch();
  const { 
    totalAmount, 
    serviceCartArr, 
    onSubmit, 
    isLoading, 
    schema, 
    isDevoteeLoggedIn, 
    devoteeData, 
    country, 
    state,
    handleChildrenRemove,
    increaseQuantity,
    decreaseQuantity,
    city,
    handleCountryChange,
    handleStateChange
  } = props;
  // service product display related data-----------------------------

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (isDevoteeLoggedIn) {
      reset({
        email: devoteeData?.email,
        first_name: devoteeData?.first_name,
        last_name: devoteeData?.last_name,
        country: devoteeData?.country,
        address: devoteeData?.address,
        city: devoteeData?.city,
        contact_number: String(devoteeData?.contact_number || ""),
        zipCode: devoteeData?.zipCode || "",
      });
    } else if (!isDevoteeLoggedIn & true) {
      reset({
        email: devoteeData?.email,
        first_name: devoteeData?.first_name,
        last_name: devoteeData?.last_name,
        country: devoteeData?.country,
        state: devoteeData?.state,
        address: devoteeData?.address,
        city: devoteeData?.city,
        contact_number: String(devoteeData?.contact_number || ""),
        zipCode: devoteeData?.zipCode || "",
      });
    }
  }, [isDevoteeLoggedIn]);

  const handleEmptyPoojaBasket = () => {
    dispatch(updateCart());
  };

  return (
    <>
      <Container className=" py-5">
        <Grid className="text-center mb-5">
          <h6 className="text-primary text-uppercase">Payment</h6>
          <h1 className="mb-3">Payment Details</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Proceed to Pay</li>
            </ol>
          </nav>
        </Grid>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (serviceCartArr?.length > 0) {
              handleSubmit(onSubmit)();
            } else {
              toast.error("Please add a service. Cart is empty");
            }
          }}
        >
          <Grid container spacing={3}>
            {/* Left Side - User Info */}
            <Grid item xs={12} md={4}>
              <Card variant="outlined">
                <CardHeader
                  title={
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <h5>
                        {isDevoteeLoggedIn
                          ? "Devotee Details"
                          : "Guest Details"}
                      </h5>
                      {!isDevoteeLoggedIn && (
                        <Button
                          size="small"
                          variant="outlined"
                          component={Link}
                          to={`/login?redirect=${currentUrlPath}`}
                        >
                          Login
                        </Button>
                      )}
                    </Box>
                  }
                />
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        {...register("first_name")}
                        label="First Name *"
                        fullWidth
                        error={!!errors.first_name}
                        helperText={errors.first_name?.message}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        {...register("last_name")}
                        label="Last Name *"
                        fullWidth
                        error={!!errors.last_name}
                        helperText={errors.last_name?.message}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        {...register("email")}
                        label="Email *"
                        fullWidth
                        error={!!errors.email}
                        helperText={errors.email?.message}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Controller
                        control={control}
                        name="contact_number"
                        render={({ field }) => (
                          <MuiTelInput
                            {...field}
                            defaultCountry="US"
                            fullWidth
                            label="Contact Number"
                            error={!!errors.contact_number}
                            helperText={errors.contact_number?.message}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        {...register("company_name")}
                        label="Company Name"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        {...register("address")}
                        label="Address *"
                        fullWidth
                        error={!!errors.address}
                        helperText={errors.address?.message}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="country"
                        render={({ field, fieldState }) => {
                          return (
                            <FormControl
                              key={field.value}
                              fullWidth
                              error={fieldState?.error?.message}
                              className="dropdown-margin-top"
                            >
                              <InputLabel id="demo-simple-select-label">
                                Select Country *
                              </InputLabel>
                              <Select
                                {...field}
                                labelId="demo-simple-select-label"
                                label="Select Country *"
                                onChange={async (e) => {
                                  field.onChange(e.target.value);
                                  handleCountryChange(e.target.value);
                                }}
                              >
                                {country
                                  ?.map((item) => (
                                    <MenuItem key={item.isoCode} value={item.isoCode}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                              <FormHelperText error>
                                {fieldState?.error?.message}
                              </FormHelperText>
                            </FormControl>
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="state"
                        render={({ field, fieldState }) => {
                          return (
                            <FormControl
                              key={field.value}
                              fullWidth
                              error={fieldState?.error?.message}
                              className="dropdown-margin-top"
                            >
                              <InputLabel id="demo-simple-select-label">
                                Select State *
                              </InputLabel>
                              <Select
                                {...field}
                                labelId="demo-simple-select-label"
                                label="Select State *"
                                onChange={async (e) => {
                                  field.onChange(e.target.value);                            
                                  handleStateChange(e.target.value,watch('country'));
                                }}
                                defaultValue={field.value}
                              >
                                {state
                                  ?.map((item) => (
                                    <MenuItem key={item.isoCode} value={item.isoCode}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                              <FormHelperText error>
                                {fieldState?.error?.message}
                              </FormHelperText>
                            </FormControl>
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        control={control}
                        name="city"
                        render={({ field, fieldState }) => {
                          return (
                            <FormControl
                              key={field.value}
                              fullWidth
                              error={fieldState?.error?.message}
                              className="dropdown-margin-top"
                            >
                              <InputLabel id="demo-simple-select-label">
                                Select City *
                              </InputLabel>
                              <Select
                                {...field}
                                labelId="demo-simple-select-label"
                                label="Select State *"
                                defaultValue={field.value}
                              >
                                {city.map((city) => (
                                  <MenuItem key={city.name} value={city.name}>
                                    {city.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              <FormHelperText error>
                                {fieldState?.error?.message}
                              </FormHelperText>
                            </FormControl>
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        {...register("zipCode")}
                        margin="normal"
                        fullWidth
                        label="Zip Code *"
                        error={errors?.zipCode?.message}
                        helperText={errors?.zipCode?.message}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...register("use_for_billing")}
                            defaultChecked
                          />
                        }
                        label={`Use ${
                          isDevoteeLoggedIn ? "Devotee" : "Guest"
                        } details for billing`}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            {/* Right Side - Basket + Payment */}
            <Grid item xs={12} md={8}>
              {/* Basket */}
              <Card variant="outlined" sx={{ mb: 3 }}>
                <CardHeader
                  title={<h5 style={{ margin: 0 }}>Puja Basket Items</h5>}
                  action={
                    <Button
                      size="small"
                      className="text-white"
                      variant="contained"
                      onClick={handleEmptyPoojaBasket}
                    >
                      Empty Basket
                    </Button>
                  }
                />
                <CardContent>
                  {serviceCartArr?.length > 0 ? (
                    serviceCartArr.map((item) => (
                      <Card key={item._id} variant="outlined" sx={{ mb: 2 }}>
                        <CardHeader
                          title={<h6 style={{ margin: 0 }}>{item.title}</h6>}
                          action={
                            <h6 style={{ color: "#1976d2", margin: 0 }}>
                              {item?.type === 3
                                ? `$ ${item?.total}`
                                : `$ ${item.amount * (item.quantity || 1)}`}
                            </h6>
                          }
                          sx={{ bgcolor: "#f5f5f5", py: 1 }}
                        />
                        <CardContent>
                          <Grid container spacing={1}>
                            <Grid item xs={11}>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <small>Date:</small>
                                  <p style={{ margin: 0 }}>
                                    {moment
                                      .utc(
                                        new Date(
                                          item?.selectedDate || new Date()
                                        )
                                      )
                                      .format("dddd, MMMM Do YYYY")}
                                  </p>
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                  display={"flex"}
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                >
                                  <Button
                                    variant="contained"
                                    onClick={() => decreaseQuantity(item)}
                                    className="quantity-btn2"
                                    color="primary"
                                  >
                                    <Remove fontSize="10px" />
                                  </Button>
                                  <div>
                                    <small>Qty:</small>
                                    <p
                                      style={{ margin: 0, textAlign: "center" }}
                                    >
                                      {item?.quantity || 1}
                                    </p>
                                  </div>
                                  <Button
                                    variant="contained"
                                    onClick={() => increaseQuantity(item)}
                                    className="quantity-btn2"
                                    color="primary"
                                  >
                                    <Add fontSize="10px" />
                                  </Button>
                                </Grid>
                                <Grid
                                  item
                                  xs={3}
                                  display={"flex"}
                                  justifyContent={"center"}
                                  alignItems={"center"}
                                >
                                  <small>Price:</small>
                                  <p style={{ margin: 0 }}>
                                    {item?.type === 3
                                      ? `$ ${item?.total}`
                                      : `$ ${item.amount}`}
                                  </p>
                                </Grid>
                                {item.category && (
                                  <Grid item xs={12}>
                                    <small>Category:</small>
                                    <p style={{ margin: 0 }}>{item.category}</p>
                                  </Grid>
                                )}
                                {item.booking_config && (
                                  <Grid item xs={12}>
                                    <small>Details:</small>
                                    <p style={{ margin: 0 }}>
                                      {item.booking_config}
                                    </p>
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              xs={1}
                              display={"flex"}
                              alignItems={"center"}
                            >
                              <ConsentDialog
                                cartItem={item}
                                onAgree={handleChildrenRemove}
                              />
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    ))
                  ) : (
                    <p style={{ color: "#6c757d", margin: 0 }}>
                      Your puja basket is empty
                    </p>
                  )}
                </CardContent>
              </Card>

              {/* Payment Gateway Selection */}
              <Card variant="outlined">
                <CardContent>
                  <h5 style={{ marginTop: 0, marginBottom: 16 }}>
                    Payment Method
                  </h5>
                  <Controller
                    name="paymentGateway"
                    control={control}
                    render={({ field }) => (
                      <Grid container spacing={2}>
                        {templeJson.paymentGateways.map((method) => (
                          <Grid item xs={12} sm={6} key={method.value}>
                            <Box
                              onClick={() => field.onChange(method.value)}
                              sx={{
                                border:
                                  field.value === method.value
                                    ? "2px solid #1976d2"
                                    : "1px solid #ccc",
                                borderRadius: 2,
                                p: 2,
                                textAlign: "center",
                                cursor: "pointer",
                                bgcolor:
                                  field.value === method.value
                                    ? "#e3f2fd"
                                    : "inherit",
                              }}
                            >
                              <img
                                src={`${process.env.REACT_APP_S3_BASE_URL}${method.imageUrl}`}
                                alt={method.name}
                                style={{ height: 20, marginBottom: 8 }}
                              />
                              <p style={{ margin: 0 }}>{method.name}</p>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  />
                </CardContent>
              </Card>
              <Card variant="outlined" className="card shadow-sm mb-4">
                <CardContent className="card-body">
                  <h5 className="card-title mb-3">Order Summary</h5>

                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <span>Subtotal:</span>
                    <span>${totalAmount}</span>
                  </Box>

                  <Divider sx={{ my: 1 }} />

                  <Box display="flex" justifyContent="space-between" mb={3}>
                    <strong>Total:</strong>
                    <strong className="text-primary">${totalAmount}</strong>
                  </Box>

                  <Button
                    className="w-100 text-white"
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isLoading || !watch("paymentGateway")}
                    fullWidth
                  >
                    {isLoading ? (
                      <>
                        <CircularProgress
                          color="inherit"
                          size={20}
                          sx={{ mr: 1 }}
                        />
                        Processing...
                      </>
                    ) : (
                      "Pay Now"
                    )}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </form>
      </Container>
    </>
  );
}
